import { pickAll, prop, propOr } from 'ramda';
import { createSelector } from 'reselect';

import { EMPTY_VALUES } from 'constants/general';

import {
	leadsFromMarketPlaceTypes,
	leadsOutOfMarketPlaceTypes,
	NAME,
	quickFilter,
	toggleButtonGroupValues,
} from './constants';

const getRoot = prop(NAME);

export const getToggleValue = createSelector(getRoot, propOr(toggleButtonGroupValues.MY_TEAM, 'toggleValue'));
export const getMyTeam = createSelector(getRoot, propOr(EMPTY_VALUES.ARRAY, 'myTeam'));
export const getBruttoProductionTeamActivities = createSelector(
	getRoot,
	propOr(EMPTY_VALUES.ARRAY, 'bruttoProductionTeamActivities'),
);
export const getSellectedSeller = createSelector(getRoot, propOr(null, 'selectedSeller'));
export const getLeadsSummary = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'leadsSummary'));
export const getLeadsOutOfMarketPlace = createSelector(getLeadsSummary, (leadsSummary) =>
	pickAll(leadsOutOfMarketPlaceTypes, leadsSummary),
);
export const getLeadsFromMarketPlace = createSelector(getLeadsSummary, (leadsSummary) =>
	pickAll(leadsFromMarketPlaceTypes, leadsSummary),
);
export const getInfoGraphicsData = createSelector(getRoot, propOr(EMPTY_VALUES.OBJECT, 'infoGraphicsData'));
export const getBruttoPeriodTableQuickFilter = createSelector(
	getRoot,
	propOr(quickFilter.TODAY_MINUS_TWO_DAYS, 'bruttoPeriodQuickFilter'),
);
